import React, { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, Collapse } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { Form, Select } from "antd";
import { verifyNewIds } from "../../services/apis/collections/oAuthApis";
import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, RID } from "../../constants/localStoreKeys";
import { pushNotification } from "utils/notifications";

import {
  getMessageRequestPayload,
  wrapRequestPayload,
} from "../../helpers/request/RequestPayload";

import { getModifyPageSubscriptionTopic, inviteExternalUsersTopic } from "hooks/MQTTConstants";

const { TextArea } = Input;

const InvitePeopleModal: FC<{ onClose: () => void; socket?: ISocket; page?: boolean }> = (
  props
) => {
  const { onClose, socket, page } = props;
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [key, setKey] = useState("");
  const { selectedItem } = useSelector((state: RootState) => state.search);
  const [registerForm] = Form.useForm();
  const { getLocalStorageItem } = useLocalStorageService();
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState(false);
  const [type, setType] = useState("email");

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const dispatch = useDispatch();

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const onSubmitHandler = async (values: any) => {
    const { email, phone, nickname } = values;
    setError("");
    if (!email && !phone) {
      setError("Please enter email or phone number");
      return;
    }

    const notificationChannels = [];
    if (email) notificationChannels.push({ email });
    if (phone) notificationChannels.push({ phone });

    setSaving(true);
    setTimeout(()=>{
      setSaving(false);
    }, 2000);
    // const data = {
    //     userIds: [{ email }, { phone: phone }],
    //   };

    // yield put({type: SHOW_PROGRESS})
    // const response = await verifyNewIds({ data });
    // if(response.status){

    if(page){
    sendPageUpdateEvent("addPageNonBeamerMember", {
      role: "write",
      invitation: { notificationChannels },
      nickname
    });
    }
    else{
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        inviteExternalUsersTopic(),
        wrapRequestPayload({
          userId: localStorage.getItem('RID'),
          notificationChannels: {
            email,
            phone
          },
          nickname
        })
      );
    }
    setIsModalVisible(false);
    onClose && onClose();
    // }
    // else{
    // pushNotification(
    // "Email or phone already exist",
    // "error",
    // 'TOP_CENTER',
    // 1000
    //   );
    // }
  };

  return (
    // <Modal
    //   title="Invite people"
    //   visible={isModalVisible}
    //   onCancel={handleCancel}
    //   width="480px"
    //   className="beam-modal"
    //   footer={[]}
    //   destroyOnClose={true}
    // >

<Collapse defaultActiveKey={[]} bordered={false}>
            <Collapse.Panel
              header={
                <Row>
                  <Col span={24}>
                    <p className="mb-1" style={{ color: "#000000", fontSize: 16 }}>
                      Invite via
                    </p>
                  </Col>
                </Row>
              }
              key="1"
            >
              
      <Form
        className="auth-form"
        name="register-form"
        id="register-form"
        layout="vertical"
        form={registerForm}
        onFinish={onSubmitHandler}
        requiredMark={false}
      >
        <Row>
          <Col span={8}>
            <Button
              onClick={() => {
                setType("email");
              }}
              className={`beam-btn ${
                type === "email" ? "green-btn cover" : ""
              }`}
            >
              Email
            </Button>
          </Col>
          <Col span={8}>
            <Button
              onClick={() => {
                setType("phone");
              }}
              className={`beam-btn ${
                type === "phone" ? "green-btn cover" : ""
              }`}
            >
              Phone
            </Button>
          </Col>
        </Row>

        <Row className="mt-4">
        <Col span={24}>
        <Form.Item
                name="nickname"
                rules={[
                  {
                    required: true,
                    message: "**Required field",
                  },
                ]}
              >
                <Input placeholder="Nickname" />
              </Form.Item>
        </Col>
          <Col span={24}>
            {type === "email" && (
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid Email!",
                  },
                  {
                    required: true,
                    message: "**Required field",
                  },
                ]}
              >
                <Input type="email" placeholder="Email" />
              </Form.Item>
            )}

            {type === "phone" && (
              <Form.Item name="phone" rules={[
                {
                  required: true,
                  message: "**Required field",
                },
              ]}>
                <Input type="text" placeholder="Phone number (include +)" />
              </Form.Item>
            )}
            {error && (
              <Form.Item>
                <p className="error">{error}</p>
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row className="action-grp">
          <Col span={24} className="pr-2">
            <Form.Item>
              <Button
                className="beam-btn green-btn cover w-full"
                loading={saving}
                type="primary"
                htmlType="submit"
                onClick={() => setError("")}
              >
                Invite
              </Button>
            </Form.Item>
          </Col>
          {/* <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col> */}
        </Row>
      </Form>
      </Collapse.Panel>
      </Collapse>
    // </Modal>
  );
};

export default InvitePeopleModal;
